import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", { class: "text-primary" }, null, -1)
const _hoisted_2 = { class: "text-center text-h1 text-weight-bold text-snabb1" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "text-dark text-weight-medium" }, "¿Quieres continuar?", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_avatar = _resolveComponent("q-avatar")!
  const _component_s_button_primary = _resolveComponent("s-button-primary")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref: "dialogRef",
    onHide: _ctx.onDialogHide,
    position: "top"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "rounded-borders q-py-lg q-px-sm q-dialog-plugin text-center" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "text-center q-py-none" }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_q_form, { onSubmit: _ctx.onDialogOK }, {
            default: _withCtx(() => [
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_avatar, {
                    size: "100px",
                    "font-size": "80px",
                    color: "white",
                    "text-color": "secondary",
                    icon: "flight_takeoff"
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_q_card_section, null, {
                default: _withCtx(() => [
                  _createElementVNode("h3", {
                    class: "text-primary",
                    innerHTML: _ctx.subtitle
                  }, null, 8, _hoisted_3),
                  _createElementVNode("h5", {
                    class: "text-dark",
                    innerHTML: _ctx.text
                  }, null, 8, _hoisted_4)
                ]),
                _: 1
              }),
              _createVNode(_component_q_card_actions, { vertical: "" }, {
                default: _withCtx(() => [
                  _hoisted_5,
                  _createVNode(_component_s_button_primary, {
                    label: "Si",
                    unelevated: "",
                    type: "submit",
                    class: "q-mb-md",
                    color: "secondary"
                  }),
                  _createVNode(_component_s_button_primary, {
                    unelevated: "",
                    label: "No",
                    outline: "",
                    color: "secondary",
                    onClick: _ctx.onDialogHide
                  }, null, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onSubmit"]),
          _withDirectives(_createVNode(_component_q_btn, {
            class: "absolute-top-right",
            fab: "",
            outline: "",
            flat: "",
            color: "secondary",
            icon: "close"
          }, null, 512), [
            [_directive_close_popup]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onHide"]))
}